import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "./context/ContentContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Preloader from "./components/Preloader";
import CustomCursor from "./components/CustomCursor";
import BackToTop from "./components/BackToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function ScrollProgress() {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setWidth(max > 0 ? (h.scrollTop / max) * 100 : 0);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <div className="scroll-progress" style={{ width: `${width}%` }} data-testid="scroll-progress" />;
}

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <Preloader />}
      {!isAdmin && <CustomCursor />}
      {!isAdmin && <ScrollProgress />}
      {!isAdmin && <BackToTop />}
      {!isAdmin && <div className="grain-overlay" aria-hidden="true" data-testid="grain-overlay" />}
      {!isAdmin && <Header />}
      <div key={location.pathname} className={isAdmin ? undefined : "page-transition"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ContentProvider>
        <BrowserRouter>
          <Shell />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#1c1c1c",
                color: "#fafafa",
                border: "1px solid rgba(255,255,255,0.15)",
                fontFamily: "'Comfortaa', sans-serif",
                fontSize: "13px",
              },
            }}
          />
        </BrowserRouter>
      </ContentProvider>
    </div>
  );
}

export default App;
